var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutletIcon3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 33,
    viewBox: "0 0 22 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 1.2998C16.8302 1.2998 21.5 5.70223 21.5 11.0537C21.4999 13.239 20.8386 15.6613 19.8203 18.0869C18.804 20.5079 17.4444 22.9023 16.0791 25.0234C14.7146 27.1433 13.3497 28.9823 12.3252 30.291C11.8131 30.9451 11.3867 31.4663 11.0889 31.8232C11.0581 31.8601 11.0279 31.8944 11 31.9277C10.9721 31.8944 10.9419 31.8601 10.9111 31.8232C10.6133 31.4663 10.1869 30.9451 9.6748 30.291C8.65027 28.9823 7.28542 27.1433 5.9209 25.0234C4.55556 22.9023 3.19601 20.5079 2.17969 18.0869C1.16145 15.6613 0.500067 13.239 0.5 11.0537C0.5 5.70223 5.1698 1.2998 11 1.2998ZM12.8809 7.52246C11.9835 7.13754 10.9949 7.03695 10.041 7.2334C9.08717 7.42991 8.21335 7.9146 7.5293 8.62305C6.84547 9.33129 6.38116 10.2314 6.19336 11.209C6.00562 12.1865 6.10206 13.2002 6.4707 14.1221C6.83938 15.0439 7.46478 15.8348 8.27051 16.3926C9.07669 16.9505 10.0269 17.25 11 17.25H11.001C12.3056 17.2484 13.5528 16.7105 14.4697 15.7607C15.3861 14.8116 15.8989 13.5283 15.9004 12.1934V12.1924C15.9003 11.1961 15.6152 10.2207 15.0791 9.38965C14.5428 8.55835 13.7782 7.90741 12.8809 7.52246Z",
    fill: "#ED870F",
    stroke: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.4504,
    cy: 12.3498,
    r: 6.05,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.66028 14.6635L14.2574 9.9945C14.4691 9.77955 14.8157 9.77955 15.0274 9.9945C15.2344 10.2048 15.2344 10.5423 15.0274 10.7526L9.66028 16.2035L6.97381 13.4751C6.76675 13.2648 6.76675 12.9273 6.97381 12.717C7.18545 12.502 7.5321 12.502 7.74374 12.717L9.66028 14.6635Z",
    fill: "#ED870F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutletIcon3);
export default __webpack_public_path__ + "static/media/OutletIcon3.b2ff3c4e6d6f002b09bd0808234c1dee.svg";
export { ForwardRef as ReactComponent };